module.exports = __webpack_public_path__ + "static/media/chevron-left-double.170a386f.svg";